import { render, staticRenderFns } from "./MainResidenceTypeChart.vue?vue&type=template&id=251e71a5&scoped=true&"
import script from "./MainResidenceTypeChart.vue?vue&type=script&lang=js&"
export * from "./MainResidenceTypeChart.vue?vue&type=script&lang=js&"
import style0 from "./MainResidenceTypeChart.vue?vue&type=style&index=0&id=251e71a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251e71a5",
  null
  
)

export default component.exports